import { render, staticRenderFns } from "./BaseDataSource.vue?vue&type=template&id=725cfb42&"
import script from "./BaseDataSource.vue?vue&type=script&lang=js&"
export * from "./BaseDataSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports